"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsTableBody = void 0;
var _react = _interopRequireWildcard(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _baseInclusions = require("../../constants/baseInclusions");
var _productItemLabel = require("../productColumn/productItemLabel");
var _productPopupLink = require("../productColumn/productPopups/productPopupLink");
var _productItemValue = require("../productColumn/productItemValue");
var _tableContext = require("./stateHelpers/tableContext");
var _tableHelpers = require("../../helpers/tableHelpers");
var _staffModeConfig = require("../staffMode/staffModeConfig");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/no-array-index-key */
var ProductsTableBody = exports.ProductsTableBody = function ProductsTableBody(_ref) {
  var _ref$plans = _ref.plans,
    plans = _ref$plans === void 0 ? {} : _ref$plans,
    formContext = _ref.formContext,
    _ref$onSelectedOption = _ref.onSelectedOptionChange,
    onSelectedOptionChange = _ref$onSelectedOption === void 0 ? function () {} : _ref$onSelectedOption,
    _ref$onGroupDisplaySt = _ref.onGroupDisplayStateChange,
    onGroupDisplayStateChange = _ref$onGroupDisplaySt === void 0 ? function () {} : _ref$onGroupDisplaySt;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    brandTextElements = _useContext$tableCont.brandTextElements,
    AddOnsMap = _useContext$tableCont.AddOnsMap,
    ProductGroupsKeyedByPlanNumber = _useContext$tableCont.ProductGroupsKeyedByPlanNumber,
    productsAreMerged = _useContext$tableCont.productsAreMerged,
    _useContext$tableStat = _useContext.tableState,
    staffMode = _useContext$tableStat.staffMode,
    groupDisplayStates = _useContext$tableStat.groupDisplayStates,
    activeProductGroup = _useContext$tableStat.activeProductGroup,
    selectedOptions = _useContext$tableStat.selectedOptions,
    selectedProduct = _useContext$tableStat.selectedProduct,
    mobileMode = _useContext$tableStat.mobileSettings.mobileMode;
  var HandleRadioOptionSelect = function HandleRadioOptionSelect(_ref2) {
    var productDefinition = _ref2.productDefinition,
      labelKey = _ref2.labelKey,
      radioValue = _ref2.radioValue;
    var planNumber = productDefinition.planNumber;
    var planProductGroup = ProductGroupsKeyedByPlanNumber["Plan_".concat(planNumber)];
    var adjustedSelectedOptions = _objectSpread({}, selectedOptions);
    if (productsAreMerged) {
      adjustedSelectedOptions.merged[planProductGroup] = _objectSpread(_objectSpread({}, selectedOptions.merged[planProductGroup] || {}), {}, _defineProperty({}, labelKey, radioValue));
    } else {
      adjustedSelectedOptions.allPlans[planNumber] = _objectSpread(_objectSpread({}, selectedOptions.allPlans[planNumber] || {}), {}, _defineProperty({}, labelKey, radioValue));
    }

    // If the variants and base are displayed in a merged view set the
    // excess for all the variants to match the chosen value
    var variantsMap = GetAllVariantPlanNumbers(planNumber, labelKey);
    if (variantsMap) {
      variantsMap.forEach(function (variant) {
        var variantPlanNumber = variant.planNumber;
        adjustedSelectedOptions.allPlans[variantPlanNumber] = _objectSpread(_objectSpread({}, adjustedSelectedOptions.allPlans[variantPlanNumber] || {}), {}, _defineProperty({}, labelKey, radioValue));
      });
    }
    onSelectedOptionChange({
      adjustedSelectedOptions: adjustedSelectedOptions
    });
  };
  var GetAllVariantPlanNumbers = function GetAllVariantPlanNumbers(planNumber, labelKey) {
    if ((labelKey === 'excess' || labelKey === 'levelOfCover') && productsAreMerged) {
      // eslint-disable-next-line consistent-return
      var newAddOnsMap;
      Object.entries(AddOnsMap).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          values = _ref4[1];
        var planNumberExists = "".concat(key) === "".concat(planNumber) || values.some(function (plan) {
          return plan.planNumber === planNumber;
        });
        if (planNumberExists) {
          newAddOnsMap = [].concat(_toConsumableArray(values), [{
            planNumber: key
          }]);
        }
      });
      return newAddOnsMap;
    }
    return null;
  };
  var HandleToggleVisibility = function HandleToggleVisibility(groupIndex) {
    var adjustedDisplayStates = _objectSpread(_objectSpread({}, groupDisplayStates), {}, _defineProperty({}, groupIndex, !groupDisplayStates[groupIndex]));
    onGroupDisplayStateChange(adjustedDisplayStates);
  };
  return /*#__PURE__*/_react["default"].createElement("tbody", null, brandTextElements && brandTextElements.labelGroups && brandTextElements.labelGroups.map(function (group, groupIndex) {
    var groupStyle = group.groupStyle,
      items = group.items,
      groupLabel = group.groupLabel,
      showAllButtonCssClass = group.showAllButtonCssClass;
    var groupIsVisible = groupDisplayStates[groupIndex];
    var groupMarkup = [];
    var totalNumColumns = Object.values(plans).length + 1;
    if (groupStyle === 'accordion') {
      groupMarkup.push( /*#__PURE__*/_react["default"].createElement("tr", {
        key: "group_".concat(groupIndex, "_accordion"),
        className: "productTableRowAccordionControl"
      }, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: "100%"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "button primary",
        onClick: function onClick() {
          return HandleToggleVisibility(groupIndex);
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "labelText"
      }, groupLabel), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: groupIsVisible ? 'minus' : 'plus'
      })))));
    }
    if (groupStyle === 'fixed' || groupStyle === 'cards' || groupIsVisible) {
      Object.entries(items).forEach(function (_ref5, rowIndex) {
        var _ref6 = _slicedToArray(_ref5, 2),
          labelKey = _ref6[0],
          labelDefinition = _ref6[1];
        var group = labelDefinition.group,
          isHidden = labelDefinition.isHidden;
        if (!group || groupDisplayStates["group".concat(group)] && groupDisplayStates["group".concat(group)].isVisible) {
          groupMarkup.push( /*#__PURE__*/_react["default"].createElement("tr", {
            className: "".concat(labelKey, " ").concat(labelDefinition.rowStyle ? labelDefinition.rowStyle : ''),
            key: "product_".concat(rowIndex, "_").concat(labelKey)
          }, plans && Object.values(plans).map(function (productDefinition, columnIndex) {
            var _labelDefinition$dyna;
            var customCoverDetails = productDefinition.customCoverDetails,
              planNumber = productDefinition.planNumber;
            var planProductGroup = ProductGroupsKeyedByPlanNumber["Plan_".concat(planNumber)];
            var dynamicRelationshipMap = [];
            if ((labelDefinition === null || labelDefinition === void 0 || (_labelDefinition$dyna = labelDefinition.dynamicRelationship) === null || _labelDefinition$dyna === void 0 ? void 0 : _labelDefinition$dyna.length) > 0) {
              labelDefinition === null || labelDefinition === void 0 || labelDefinition.dynamicRelationship.forEach(function (relation) {
                dynamicRelationshipMap.push(_defineProperty({}, relation, items[relation]));
              });
            }
            var coverDetails = _objectSpread(_objectSpread({}, _baseInclusions.BaseInclusions), customCoverDetails);
            var getCellCssClass = function getCellCssClass(_ref7) {
              var isValueCell = _ref7.isValueCell;
              return (0, _tableHelpers.GetCellCssClass)({
                planNumber: planNumber,
                planProductGroup: planProductGroup,
                activeProductGroup: activeProductGroup,
                selectedProduct: selectedProduct,
                isValueCell: isValueCell,
                labelDefinition: labelDefinition,
                productsAreMerged: productsAreMerged
              });
            };

            // Hiding of table row
            if (isHidden) return null;
            return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
              key: "product_".concat(rowIndex, "_").concat(labelKey, "_").concat(columnIndex)
            }, columnIndex === 0 && labelKey === 'divider' && /*#__PURE__*/_react["default"].createElement("th", {
              colSpan: "100%",
              className: "productItemLabel ".concat(mobileMode ? getCellCssClass({
                isValueCell: false
              }) : '')
            }, /*#__PURE__*/_react["default"].createElement(_productItemLabel.ProductItemLabel, {
              brandFootnotes: brandTextElements.footnotes,
              labelKey: labelKey,
              labelDefinition: labelDefinition
            }), /*#__PURE__*/_react["default"].createElement(_productPopupLink.ProductPopupLink, {
              labelKey: labelKey,
              labelDefinition: labelDefinition,
              productDefinition: productDefinition
            })), columnIndex === 0 && labelKey !== 'divider' && /*#__PURE__*/_react["default"].createElement("th", {
              className: "productItemLabel ".concat(mobileMode ? getCellCssClass({
                isValueCell: false
              }) : '')
            }, /*#__PURE__*/_react["default"].createElement(_productItemLabel.ProductItemLabel, {
              brandFootnotes: brandTextElements.footnotes,
              labelKey: labelKey,
              labelDefinition: labelDefinition
            }), /*#__PURE__*/_react["default"].createElement(_productPopupLink.ProductPopupLink, {
              labelKey: labelKey,
              labelDefinition: labelDefinition,
              productDefinition: productDefinition
            })), labelKey !== 'divider' && /*#__PURE__*/_react["default"].createElement("td", {
              className: getCellCssClass({
                isValueCell: true
              })
            }, staffMode && _staffModeConfig.StaffModeConfig[labelKey] && _staffModeConfig.StaffModeConfig[labelKey].preQuestion ? _staffModeConfig.StaffModeConfig[labelKey].preQuestion({
              plan: productDefinition
            }) : null, /*#__PURE__*/_react["default"].createElement(_productItemValue.ProductItemValue, {
              labelKey: labelKey,
              labelDefinition: labelDefinition,
              formContext: formContext,
              dynamicRelationship: dynamicRelationshipMap,
              disabled: (0, _tableHelpers.ProductGroupFilterExcludesPlan)({
                productGroup: planProductGroup,
                activeProductGroup: activeProductGroup
              }),
              coverDetails: coverDetails,
              productDefinition: productDefinition,
              productGroup: planProductGroup,
              onRadioSelect: HandleRadioOptionSelect
            }), labelDefinition.valueNote && /*#__PURE__*/_react["default"].createElement("span", {
              className: "valueNote"
            }, labelDefinition.valueNote), /*#__PURE__*/_react["default"].createElement(_productPopupLink.ProductPopupLink, {
              labelKey: labelKey,
              labelDefinition: labelDefinition,
              disabled: (0, _tableHelpers.ProductGroupFilterExcludesPlan)({
                productGroup: planProductGroup,
                activeProductGroup: activeProductGroup
              }),
              productDefinition: productDefinition,
              isLabelCell: false
            }), staffMode && _staffModeConfig.StaffModeConfig[labelKey] && _staffModeConfig.StaffModeConfig[labelKey].postQuestion ? _staffModeConfig.StaffModeConfig[labelKey].postQuestion({
              plan: productDefinition
            }) : null));
          })));
        }
      });
    }
    if (groupStyle === 'showAll' && !groupIsVisible) {
      groupMarkup.push( /*#__PURE__*/_react["default"].createElement("tr", {
        key: "group_".concat(groupIndex, "_showAll"),
        className: "productTableShowAllButton"
      }, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: Object.entries(plans).length + 1
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: showAllButtonCssClass || 'button primary text_only',
        onClick: function onClick() {
          return HandleToggleVisibility(groupIndex);
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "labelText"
      }, groupLabel), /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Click to view all features for this product"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: "arrow-down2"
      })))));
    }
    if (groupStyle === 'showAllFullSpan' && !groupIsVisible) {
      groupMarkup.push( /*#__PURE__*/_react["default"].createElement("tr", {
        key: "group_".concat(groupIndex, "_showAll"),
        className: "productTableShowAllButton"
      }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "button primary text_only",
        onClick: function onClick() {
          return HandleToggleVisibility(groupIndex);
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "labelText"
      }, groupLabel), /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Click to view all features for this product"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: "arrow-down2"
      })))));
    }
    if ((groupStyle === 'showAll' || groupStyle === 'showAllFullSpan') && groupIsVisible) {
      groupMarkup.push( /*#__PURE__*/_react["default"].createElement("tr", {
        key: "group_".concat(groupIndex, "_hideExpanded"),
        className: "productTableShowAllButton"
      }, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: Object.entries(plans).length + 1
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "button primary text_only",
        onClick: function onClick() {
          return HandleToggleVisibility(groupIndex);
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "labelText"
      }, "Hide Features"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: "arrow-up2"
      })))));
    }
    return groupMarkup;
  }));
};
ProductsTableBody.propTypes = {
  /* eslint-disable-next-line react/forbid-prop-types */
  plans: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  /* eslint-disable-next-line react/forbid-prop-types */
  formContext: _propTypes["default"].any,
  onSelectedOptionChange: _propTypes["default"].func,
  onGroupDisplayStateChange: _propTypes["default"].func
};